<template>
  <div class="hezhi-filter">
    <div class="container">
      <!-- 彩种选择 -->
      <el-form :inline="true" size="mini" label-width="80px">
        <el-row class="first-row">
          <el-col :span="6">
            <el-form-item label="彩种">
              <el-select v-model="selectedGame" placeholder="选择彩种" @change="onGameChange">
                <el-option
                  v-for="game in gameOptions"
                  :key="game.value"
                  :label="game.label"
                  :value="game.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 和值选择 -->
        <el-row class="filter-row" style="margin-top:15px;">
          <el-col :span="24">
            <el-form-item label="和值" class="hezhi-radio-group">
              <el-radio-group v-model="filters.hezhi">
                <div class="radio-wrapper">
                  <el-radio
                    v-for="n in 28"
                    :key="n-1"
                    :label="n-1"
                    class="hezhi-radio"
                  >
                    {{ n-1 }}
                  </el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 模式选择 -->
        <el-row class="filter-row" style="margin-top:15px;">
          <el-col :span="24">
            <el-form-item label="模式">
              <el-radio-group v-model="filters.mode">
                <el-radio label="zhixuan">直选</el-radio>
                <el-radio label="zuxuan">组选</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 查询/重置按钮 -->
        <el-row class="filter-row" style="margin-top:15px;">
          <el-col :span="24" class="button-col">
            <el-button type="primary" @click="filterData" style="margin-right:10px;">查询</el-button>
            <el-button @click="resetFilters">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 结果统计 -->
      <div v-if="filteredData.length > 0" class="result-count">
        共 {{ filteredData.length }} 注
      </div>

      <!-- 网格显示号码 -->
      <div class="grid-container" v-loading="loading" element-loading-text="数据生成中...">
        <div v-for="item in filteredData" :key="item.lottery_no" class="grid-item">
          {{ item.lottery_res_red.join('') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeZhiFilter',
  data () {
    return {
      gameOptions: [
        { label: '福彩3D', value: 5 },
        { label: '排列三', value: 6 }
      ],
      selectedGame: 5,
      filters: {
        hezhi: null,
        mode: 'zhixuan' // 默认直选
      },
      filteredData: [],
      loading: false
    }
  },
  methods: {
    onGameChange () {
      this.resetFilters()
    },
    /** 生成所有组合并筛选 */
    fetchData () {
      if (this.filters.hezhi === null || this.filters.hezhi === '') {
        this.$message.error('请选择一个和值 (0-27)')
        return
      }
      this.loading = true
      const targetSum = Number(this.filters.hezhi)

      let results = []
      for (let a = 0; a <= 9; a++) {
        for (let b = 0; b <= 9; b++) {
          for (let c = 0; c <= 9; c++) {
            if (a + b + c === targetSum) {
              const nums = [a, b, c]
              if (this.filters.mode === 'zhixuan') {
                results.push({
                  lottery_no: `${results.length + 1}`,
                  lottery_res_red: nums
                })
              } else {
                const key = nums.slice().sort().join('')
                if (!results.find(r => r.key === key)) {
                  results.push({
                    key,
                    lottery_no: `${results.length + 1}`,
                    lottery_res_red: nums
                  })
                }
              }
            }
          }
        }
      }

      this.filteredData = results
      this.loading = false
    },
    filterData () {
      this.fetchData()
    },
    resetFilters () {
      this.filters.hezhi = null
      this.filteredData = []
    }
  }
}
</script>

<style scoped>
.hezhi-filter {
  padding: 20px;
  min-height: 100vh;
}

/* 容器居中 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px 30px;
  border-radius: 8px;
}

/* 和值按钮 */
.radio-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.hezhi-radio {
  flex: 1 0 13%;
  max-width: 13%;
  min-width: 40px;
  text-align: left;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s;
}
.hezhi-radio:hover {
  background-color: #f5f5f5;
}
.hezhi-radio.is-checked {
  color: #fff;
  border-color: #409EFF;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .hezhi-radio { flex: 1 0 18%; max-width: 18%; }
}
@media (max-width: 992px) {
  .hezhi-radio { flex: 1 0 22%; max-width: 22%; }
}
@media (max-width: 768px) {
  .hezhi-radio { flex: 1 0 30%; max-width: 30%; }
}
@media (max-width: 576px) {
  .hezhi-radio { flex: 1 0 45%; max-width: 45%; }
}

/* 查询/重置按钮 */
.button-col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

/* 结果统计 */
.result-count {
  margin-top: 15px;
  font-weight: bold;
  color: #333;
}

/* 网格布局 */
.grid-container {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  gap: 10px;
}
.grid-item {
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.2s;
}
.grid-item:hover {
  background: #409EFF;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/usingTools/hezhiFilter.vue